import React, { useState, useCallback } from "react";
import "./Card.scss";
import DetailedCardView from "./CardDetailedView";
import { ProjectType } from "../../Data/Constants";
import { useTranslation } from "react-i18next";
import { useSpring } from "@react-spring/web";

interface CardProps {
  id: number;
  name: string;
  content: string[];
  yearBuilt: number;
  address: string;
  city: string;
  brand: string;
  projectPage: string;
  website: string;
  category: ProjectType;
  images: { url: string }[];
  features: string[];
}

const getProjectTypeTranslationKey = (category: ProjectType) => {
  return category === ProjectType.Commercial
    ? "projects.type.commercial"
    : "projects.type.residential";
};

export const Card: React.FC<CardProps> = ({
  id,
  name,
  content,
  yearBuilt,
  city,
  website,
  category,
  images,
  features,
}) => {
  const { t } = useTranslation();
  const [isClicked, setIsClicked] = useState(false);

  const animation = useSpring({
    transform: isClicked ? "translateY(0%)" : "translateY(100%)",
  });

  const handleClick = useCallback(() => {
    setIsClicked((prev) => !prev);
  }, []);

  /*
  const handleImageClick = useCallback(
    (e: React.MouseEvent) => {
      if (!hasWebsite) {
        e.preventDefault();

        handleClick();
      }
    },

    [hasWebsite, handleClick],
  );
  */

  const handleImageClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      handleClick();
    },
    [handleClick],
  );

  /*
    const handleImageClick = useCallback(() => {
        if (website && website !== "") {
            navigate(`${website}`);
        } else {
            handleClick(); // fallback if no projectPage is set
        }
    }, [website, handleClick, navigate]);
    */

  const projectType = t(getProjectTypeTranslationKey(category));

  return (
    <div className="project-card">
         {/*
      <a
        href={hasWebsite ? website : "#"}
        onClick={handleImageClick}
        className="project-card-link"
      >
        */}
      <div onClick={handleImageClick}>
        <img
          className="project-card-image"
          src={images[0]?.url}
          alt={`${name}`}
          loading="lazy"
        />
        <div className="project-card-content">
          <h2 className="project-card-title">{name}</h2>
          <h3>{yearBuilt}</h3>
          <p className="project-card-location">{city}</p>
          {/*
                        <button className="learn-more-button" onClick={handleClick}>
                            <span>{t("card.button.text")}</span>
                            <span><FaChevronRight /></span>
                        </button>
                        */}
        </div>
      </div>
      <div className="project-card-full-background" onClick={handleClick}></div>
      <DetailedCardView
      data-lenis-prevent
        isOpen={isClicked}
        style={animation}
        id={id}
        title={name}
        description={content}
        images={images}
        yearBuilt={yearBuilt}
        category={projectType}
        location={city}
        website={website}
        features={features}
        onClose={handleClick}
      />
    </div>
  );
};

export default Card;
